import {ApolloLink, Operation} from '@apollo/client';
import {OperationDefinitionNode} from 'graphql';
import _ from 'underscore';

import {logProfilerTimingEvent} from 'performance/BenchlingProfiler';
import {QUERY_STARTED_EVENT, QUERY_FINISHED_EVENT} from 'performance/processGraphQLEvents';
import attemptCaptureBreadcrumb from 'util/attemptCaptureBreadcrumb';
import truncateJSON from 'util/truncateJSON';

export default function createObservabilityLink(): ApolloLink {
  let inFlight = 0;
  return new ApolloLink((operation: Operation, forward) => {
    operation.setContext({startTime: new Date().getTime()});
    if (inFlight === 0) {
      logProfilerTimingEvent(QUERY_STARTED_EVENT);
    }
    inFlight += 1;

    return forward(operation).map((result) => {
      const operationDefinition: OperationDefinitionNode | undefined = operation.query.definitions.find(
        (definition) => definition.kind === 'OperationDefinition'
      ) as OperationDefinitionNode;
      inFlight -= 1;
      if (inFlight === 0) {
        logProfilerTimingEvent(QUERY_FINISHED_EVENT);
      }

      if (operationDefinition) {
        const operationType = operationDefinition.operation;
        const elapsed = `${new Date().getTime() - operation.getContext().startTime} ms`;

        const data = _.isEmpty(operation.variables)
          ? {elapsed}
          : {elapsed, variables: truncateJSON(operation.variables, {maxDepth: 5})};
        attemptCaptureBreadcrumb({
          message: operation.operationName,
          category: `apollo-${operationType}`,
          level: 'info',
          data,
        });
      }

      return result;
    });
  });
}
